import { Box, Button, Grid, makeStyles, Typography } from "@material-ui/core";
import React, { useState } from "react";
import CircularCenteredLoader from "features/common/CircularCenteredLoader";
import { getDefectMemoReport, viewDefectMemoFile } from "features/Tdsat/API/TdsatApi";
import DateRangePickerTDSAT from "features/Tdsat/DateRangePickerTDSAT";
import { format } from "date-fns";
import { useSnackbar } from "contexts/SnackbarContext";

const useStyles = makeStyles((theme)=>({
  filtersContainer: {
    padding: '1rem', 
    borderBottom: '1px solid black', 
    display: 'flex', 
    gap: '15px', 
    justifyContent:'center',
    // width: '80%',
    margin: 'auto',
  },
  buttonPrint: {
    borderRadius: '0.5rem',
    border: '1px solid #AAAFB9',
    background: '#fff',
    padding: '0.5rem 1rem',
  },
  tableHeadItem:{
    // color: 'grey',
    fontFamily: 'Satoshi-Bold',
    wordBreak: 'break-word',
  },
  tableRowValue: {
    // color: '#858D98',
    fontSize: '0.9375rem',
    wordBreak: 'break-word',
    whiteSpace: 'pre-line',
  },
  valuePaper: {
    padding: "1.5rem 8px",
    cursor: "pointer",
    boxShadow: "none",
    width: "100%",
    border: "1px solid #E0E0E0",
    "&:hover": {
      background: "#E5F6EF",
      '& $downloadButton': {
        visibility: 'visible',
      }
    },
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },
}))

export default function DefectMemoReport() {
  const classes = useStyles();

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [cases, setCases] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const { showSnackbar } = useSnackbar();

  const spacing = [1,3,6,2];
  const tableHeadings = ['Sr. No.','Diary No.','Party','Action'];

  const processResponse = (data,index) => {
    const item = data;
    const arr = [
      index+1,  
      <a style={{color: '#4a3bff', cursor: 'pointer'}} onClick={()=>handleViewDefectFile(item?.defect_file_id)}>{item?.related_diary_number}</a>, 
      item?.related_name,
      'Mail already sent',
    ];
    return arr;
  }

  const reload = (start_date, end_date) => {
    setLoading(true);
    getDefectMemoReport(start_date, end_date)
    .then((res)=>{
      const response = res?.data?.error ? [] : res?.data || [];
      setCases(response);
      setLoading(false);
    })
    .catch((error)=>{
      console.log('Error: ',error);
      setLoading(false)
    })
  }

  const handleClickSubmit = () => {
    if(true){
      setSubmitted(true);
      reload(format(startDate, 'dd-MM-yyyy'), format(endDate, 'dd-MM-yyyy'));
    }
  }

  const handleViewDefectFile = async (id) => {
    try {
      const response = await viewDefectMemoFile(id);
      const link = response.data?.pre_signed_url;
      if (link) {
        const newTab = window.open();
        newTab.location.href = link;
      } else {
        showSnackbar(response?.data?.error, 'error');
      }
    } catch (error) {
      if(error?.response?.status === 400){
        showSnackbar(error?.response?.data?.error, 'error');
    }
      console.error("Failed to fetch the notice link", error);
    }
  };
  

  return (
    <Box>
      <Typography style={{fontSize:'1.5rem', padding:'2rem'}}>
        DEFECT MEMO REPORT
      </Typography>
      <Box style={{backgroundColor:'white'}}>
        <Box style={{height:'1rem'}}></Box>
        <Box className={classes.filtersContainer} style={{justifyContent:'space-between'}}>
          <DateRangePickerTDSAT startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate}/>
          <Button
            className={classes.buttonPrint}
            size="small"
            onClick={handleClickSubmit}
          >
            Search
          </Button>
        </Box>
        {submitted && (
          <Box>
            <Box style={{height: '2rem'}}/>
            <Grid container style={{ rowGap: "8px" }}>
              <Box style={{padding:'1.5rem 8px', width: '100%'}}>
                <Grid container spacing={1} justifyContent="flex-start">
                  {tableHeadings.map((heading,index)=>{
                    return (
                      <Grid key={index} item xs sm={spacing[index]}>
                        <Typography className={classes.tableHeadItem}>
                          {heading}
                        </Typography>
                      </Grid>
                    )
                  })}
                </Grid>
              </Box>
              {loading ? (
                <Box style={{margin:'auto',width:'100%',padding:'2rem 0'}}>
                  <CircularCenteredLoader/>
                </Box>
              ) : (
                cases.length !== 0 ? (
                  cases.map((dispute,index) => {
                    const processedDispute = processResponse(dispute,index);
                    return (
                      <Box key={index} className={classes.valuePaper}>
                        <Grid container spacing={1} justifyContent="flex-start">
                          {processedDispute.map((item,index)=>{
                            return (
                              <Grid key={index} item xs sm={spacing[index]}>
                                <Typography className={classes.tableRowValue}>
                                  {item}
                                </Typography>
                              </Grid>
                            )
                          })}
                        </Grid>
                      </Box>
                    );
                  })
                ) : (
                  <Grid container justify="center">
                    <Grid item>
                      <Box textAlign="center">
                        <Typography
                          style={{
                            padding: '2rem 8px',
                            textAlign: 'center',
                            fontSize: '1.5rem'
                          }}
                        >
                          No defect memo report is found for this date range.
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                )
              )}
            </Grid>
          </Box>
        )}
      </Box>
    </Box>
  )
}